import React, { useCallback, useEffect, useMemo, useState } from 'react'
import Propinsi from '../../utilities/Propinsi'
import KotaKab from '../../utilities/KotaKab'
import { Button, Col, Form, OverlayTrigger, Row, Spinner, Tooltip } from 'react-bootstrap'
import { FaEdit, FaPlus } from 'react-icons/fa'
import UserService from '../../services/user/UserService'
import { useNavigate } from 'react-router-dom'
import Card from '../../components/Card'
import DataTable from 'react-data-table-component'

const TraderAlamat = () => {
    const columns = [
        {
            name: 'Alamat',
            cell: row => row['alamat'],
        },
        {
            name: 'Propinsi',
            cell: row => <Propinsi id={row['propinsi'].substring(0, 2)} />,
        },
        {
            name: 'Kota',
            cell: row => <KotaKab id={row['kota']} />
        },
        {
            name: 'Kode Pos',
            cell: row => row['kodepos']
        },
        {
            name: 'Action',
            cell: row => (
                <>
                    {
                        localStorage.getItem("kodeTrader") !== null &&
                        <div className="row">
                            <div className="col-12 mb-1">
                                <OverlayTrigger placement="bottom" overlay={
                                    <Tooltip >Ubah Alamat</Tooltip>}>

                                    <Button size="sm" variant="warning" onClick={() => handleClickEditAlamat(row)}>
                                        <FaEdit />
                                    </Button>
                                </OverlayTrigger>
                            </div>
                        </div>
                    }
                </>
            )
        }
    ]

    let userService = useMemo(() => new UserService(), [])
    let navigate = useNavigate()

    const [listAlamat, setlistAlamat] = useState([])
    const [size, setSize] = useState(10)
    const [totalData, setTotalData] = useState(0)
    const [loading, setLoading] = useState(false)

    const getlistAlamat = useCallback(async (page, size) => {
        setLoading(true)
        try {
            const response = await userService.listTraderAlamat(localStorage.getItem("kodeTrader") !== null ? localStorage.getItem("kodeTrader") : 0, null, page, size)
            setlistAlamat(response.data.data)
            setTotalData(response.data.totalData)
        } catch (error) {
            // console.log(error)
            setlistAlamat([])
        }
        setLoading(false)
    }, [userService])

    useEffect(() => {
        getlistAlamat(0, 10)
    }, [getlistAlamat])

    const handleChangePage = (page) => {
        getlistAlamat(page - 1, size)
    }

    const handlePerRowsChange = async (size, page) => {
        const _res = await userService.listTraderAlamat(localStorage.getItem("kodeTrader") !== null ? localStorage.getItem("kodeTrader") : 0, null, page - 1, size)
        setlistAlamat(_res.data.data)
        setSize(size)
    }

    const handleClickTambahAlamat = () => {
        localStorage.removeItem("dataAlamatStorage")
        navigate('/setting/trader-alamat-add-edit')
    }

    const handleClickEditAlamat = (data) => {
        console.log(data)
        localStorage.removeItem("dataAlamatStorage")
        localStorage.setItem("dataAlamatStorage", JSON.stringify(data, null, 2))
        navigate('/setting/trader-alamat-add-edit')
    }

    const [valueSearch, setValueSearch] = useState(null)
    const [loadingSearch, setLoadingSearch] = useState(false)

    const onChangeSearch = e => {
        setValueSearch(e.target.value)
    }

    const handleClickReset = () => {
        setValueSearch('')
        getlistAlamat(0, 10)
    }

    const handleClickCari = async () => {
        setLoadingSearch(true)
        const _res = await userService.listTraderAlamat(localStorage.getItem('kodeTrader') !== null ? localStorage.getItem('kodeTrader') : null, valueSearch, 0, size)
        setlistAlamat(_res.data.data)
        setTotalData(_res.data.totalData)
        setLoadingSearch(false)
    }

    return (
        <>
            <Row>
                <Col sm="12">
                    <Card>
                        <Card.Header className="d-flex justify-content-between">
                            <div className="header-title">
                                <h4 className="card-title">Pencarian Data</h4>
                            </div>
                        </Card.Header>
                        <Card.Body>
                            <div className="row">
                                <div className="col-sm-6">
                                    <Form>
                                        <Form.Group as={Row} className="form-group">
                                            <Form.Label column sm="2" className="control-label align-self-center mb-0" htmlFor="searchNib">Alamat</Form.Label>
                                            <Col sm="6">
                                                <Form.Control type="searchNib" placeholder="Alamat" className="form-control-sm" value={valueSearch} onChange={onChangeSearch} />
                                            </Col>
                                        </Form.Group>
                                    </Form>
                                </div>
                            </div>
                            <div className="row">
                                <div className="col-sm-12">
                                    <Form>
                                        <Form.Group as={Row} className="form-group">
                                            <Col sm="2">
                                                <Button type="button" variant="btn btn-primary" size="sm" onClick={() => handleClickCari()} disabled={loadingSearch}>{loadingSearch && <Spinner />}Cari</Button>{' '}
                                                <Button type="button" variant="btn btn-danger" size="sm" onClick={() => handleClickReset()}>Reset</Button>{' '}
                                            </Col>
                                        </Form.Group>
                                    </Form>
                                </div>
                            </div>
                        </Card.Body>
                    </Card>
                    <Card>
                        <Card.Header className="d-flex justify-content-between">
                            <div className="header-title">
                                <h4 className="card-title">Daftar UPI</h4>
                            </div>
                        </Card.Header>
                        <Card.Body>
                            {
                                localStorage.getItem("kodeTrader") !== null &&
                                <Button type="button" variant="primary" size="sm" onClick={() => handleClickTambahAlamat()} ><FaPlus /> Tambah</Button>
                            }
                            <div className="table-responsive border-bottom my-3">
                                {(loading && <Spinner />)}
                                <DataTable
                                    customStyles={{ headCells: { style: { 'background-color': '#00acee', 'color': 'white' } } }}
                                    columns={columns}
                                    data={listAlamat}
                                    highlightOnHover
                                    pagination
                                    paginationServer
                                    paginationTotalRows={totalData}
                                    onChangePage={handleChangePage}
                                    onChangeRowsPerPage={handlePerRowsChange}
                                    persistTableHead={true}
                                />
                            </div>
                        </Card.Body>
                    </Card>
                </Col>
            </Row>
        </>
    )
}

export default TraderAlamat